import axios from "axios";
import { endAdminSession, getAdminToken } from "../utils/functions/auth";

const urlBase = process.env.REACT_APP_URL_BACKEND_BASE;

const authHeaders = () => {
  const token = getAdminToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

const handleAuthResponse = (response) => {
  if (response?.data?.status === 401) {
    endAdminSession();
  }
  return response;
};

const signIn = async (user) => {
  let url = `${urlBase}${process.env.REACT_APP_URL_USER}`;

  const response = await axios.post(url, user);

  return response;
};

const signOut = async () => {
  let url = `${urlBase}${process.env.REACT_APP_URL_USER}`;
  const token = getAdminToken();

  const response = await axios.delete(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  return response;
};

const getAllUsers = async () => {
  const url = `${urlBase}${process.env.REACT_APP_URL_USER}?accion=allUsers`;

  const response = await axios.get(url, authHeaders());

  return handleAuthResponse(response);
};

const addUser = async (user) => {
  const url = `${urlBase}${process.env.REACT_APP_URL_USER}?accion=addUser`;

  const response = await axios.post(url, user, authHeaders());

  return handleAuthResponse(response);
};

const editUser = async (user) => {
  const url = `${urlBase}${process.env.REACT_APP_URL_USER}?accion=editUser`;

  const response = await axios.post(url, user, authHeaders());

  return handleAuthResponse(response);
};

const deleteUser = async (id) => {
  const url = `${urlBase}${process.env.REACT_APP_URL_USER}?accion=deleteUser`;

  const response = await axios.post(url, { id }, authHeaders());

  return handleAuthResponse(response);
};

export const userService = {
  signIn,
  signOut,
  getAllUsers,
  addUser,
  editUser,
  deleteUser,
};
